import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, TextField, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { utilFunctions } from "../../../_helpers";
import { StudyPreActivityFilterStructure } from "../../../_models/app.models";
import FactorySelect from "../../_shared/FactorySelect";
import ModuleSelect from "../../_shared/ModuleSelect";
import PlantSelect from "../../_shared/PlantSelect";
import SbuSelect from "../../_shared/SbuSelect";
import ShiftSelect from "../../_shared/ShiftSelect";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { alertActions, factoryActions } from "../../../_redux/actions";
import { preStudyActions } from "../../../_redux/actions/pre-study.action";
import { Autocomplete } from "@material-ui/lab";
import { ExpandMore } from "@material-ui/icons";
import FormControlWrapper from "../../_shared/FormControlWrapper";
import StyleVersionSelect from "../../_shared/StyleVersionSelect";

const PreStudyFilters = (props) => {
    const labelMinWidth = 100
    const dispatch = useDispatch();
    const { studyHeader, pageState } = props;
    const INITIAL_STATE = {
        sbuId: { value: '', validator: 'text', isRequired: false, error: null, disable: false },
        sbuCode: { value: '', validator: 'text', isRequired: true, error: null, disable: false },
        plantId: { value: studyHeader.plantId, validator: 'text', isRequired: false, error: null, disable: false },
        plantCode: { value: studyHeader.plantCode, validator: 'text', isRequired: true, error: null, disable: false },
        factoryId: { value: studyHeader.factoryId, validator: 'text', isRequired: false, error: null, disable: false },
        factoryCode: { value: studyHeader.factoryCode, validator: 'text', isRequired: true, error: null, disable: false },
        userId: { value: studyHeader.userId },
        shiftCode: { value: studyHeader.shiftCode, validator: 'text', isRequired: false, error: null, disable: false },
        moduleCode: { value: studyHeader.module, validator: 'text', isRequired: true, error: null, disable: false },
        style: { value: studyHeader.style, validator: 'text', isRequired: true, error: null, disable: false },
        styleVersion: { value: '0', validator: 'text', isRequired: true, error: null, disable: false },
        areAllFieldsFilled: { value: false }
    }

    const INITIAL_FILTERED_DATA = {
        filteredPlants: [],
        filteredFactories: [],
        filteredModules: [],
        filteredStyles: [],
        filteredStyleVersions: []
    }

    const [filtersAccordion, setFiltersAccordion] = useState(true)

    const [preStudyFilterState, setpreStudyFilterState] = useState(INITIAL_STATE);
    const [filteredData, setFilteredData] = useState(INITIAL_FILTERED_DATA)

    useEffect(() => {

        if (props.studyHeader != null
            && props.studyHeader != undefined
            && props.studyHeader.sbuCode == undefined
            && props?.sbus != null
            && props?.sbus != undefined
            && props?.sbus?.length > 0) {
            var matchedSbu = props?.sbus.find(sbu =>
                sbu.plants.filter(plant => plant.code === props.studyHeader.plantCode).some(plant =>
                    plant.factories.some(factory => factory.code === props.studyHeader.factoryCode)
                )
            )
            if (matchedSbu != undefined || matchedSbu != null) {
                props.studyHeader.sbuCode = matchedSbu.sbuCode
                const sbuIndex = props?.sbus?.map(s => s.sbuCode)?.indexOf(matchedSbu.sbuCode)
                const plantIndex = props?.sbus[sbuIndex]?.plants?.map(p => p.code)?.indexOf(props.studyHeader.plantCode)
                const factory = props?.sbus[sbuIndex]?.plants[plantIndex]?.factories.find(x => x.code == props.studyHeader.factoryCode)
                dispatch(
                    factoryActions.getModulesByFactoryCode(
                        factory.code,
                        (data) => {

                            dispatch(
                                preStudyActions.getPreStudyStyles(
                                    (stylesData) => {
                                        if (stylesData != undefined && stylesData.length > 0) {
                                            setFilteredData({
                                                ...filteredData
                                                , filteredPlants: props?.sbus[sbuIndex]?.plants
                                                , filteredFactories: props?.sbus[sbuIndex]?.plants[plantIndex]?.factories
                                                , filteredModules: data
                                                , filteredStyleVersions: stylesData[0].version?.map(x => { return { id: x.number.toString(), value: x.number.toString() } })
                                            })
                                        }
                                    },
                                    (error) => {
                                        dispatch(alertActions.triggerAlert(true, error, 'error'))
                                    }, props.studyHeader.plantCode, props.studyHeader.factoryCode, props.studyHeader.module, props.studyHeader.style
                                )
                            );
                        },
                        (error) => {
                            dispatch(alertActions.triggerAlert(true, error, 'error'))
                        }
                    )
                );

            }
        }

        setpreStudyFilterState(
            {
                ...preStudyFilterState,
                sbuId: { value: '', validator: 'text', isRequired: false, error: null, disable: false },
                sbuCode: { value: props.studyHeader.sbuCode, validator: 'text', isRequired: true, error: null, disable: false },
                plantId: { value: props.studyHeader.plantId, validator: 'text', isRequired: false, error: null, disable: false },
                plantCode: { value: props.studyHeader.plantCode, validator: 'text', isRequired: true, error: null, disable: false },
                factoryId: { value: props.studyHeader.factoryId, validator: 'text', isRequired: false, error: null, disable: false },
                factoryCode: { value: props.studyHeader.factoryCode, validator: 'text', isRequired: true, error: null, disable: false },
                userId: { value: props.studyHeader.userId },
                moduleCode: { value: props.studyHeader.module, validator: 'text', isRequired: pageState == 'CREATE', error: null, disable: false },
                shiftCode: { value: props.studyHeader.shiftCode, validator: 'text', isRequired: pageState == 'CREATE', error: null, disable: false },
                style: { value: props.studyHeader.style, validator: 'text', isRequired: pageState == 'CREATE', error: null, disable: false },
                styleVersion: { value: props.studyHeader.styleVersion, validator: 'number', isRequired: pageState == 'CREATE', error: null, disable: false }
            }

        )
    }, [props.studyHeader, props.sbus])

    useEffect(() => {

        if (pageState == "CREATE") {
            utilFunctions.validateFormData(preStudyFilterState)
                .then((data: any) => {
                    if (data[1] == true) {
                        const filter: StudyPreActivityFilterStructure = {
                            plantCode: preStudyFilterState.plantCode.value,
                            factoryCode: preStudyFilterState.factoryCode.value,
                            shiftCode: preStudyFilterState.shiftCode.value,
                            module: preStudyFilterState.moduleCode.value,
                            style: preStudyFilterState.style.value,
                            styleVersion: preStudyFilterState.styleVersion.value.toString()
                        }
                        props.onFilterChange(filter)
                    }
                })
        }

    }, [preStudyFilterState.areAllFieldsFilled.value]);

    // Handle sbu select dropdown change event
    const onSbuChange = (value) => {
        const sbuIndex = props?.sbus?.map(s => s.sbuCode)?.indexOf(value)
        setpreStudyFilterState({
            ...preStudyFilterState,
            sbuId: {
                ...preStudyFilterState.sbuId,
                value: value
            },
            sbuCode: {
                ...preStudyFilterState.sbuCode,
                value: props.sbus[sbuIndex].sbuCode
            },
            plantId: {
                ...preStudyFilterState.plantId,
                value: ''
            },
            factoryId: {
                ...preStudyFilterState.factoryId,
                value: ''
            },
            plantCode: {
                ...preStudyFilterState.plantCode,
                value: ''
            },
            factoryCode: {
                ...preStudyFilterState.factoryCode,
                value: ''
            },
            userId: {
                value: ''
            },
            moduleCode: {
                ...preStudyFilterState.moduleCode,
                value: ''
            },
            style: {
                ...preStudyFilterState.style,
                value: ''
            },
            styleVersion: {
                ...preStudyFilterState.styleVersion,
                value: '0'
            },
            areAllFieldsFilled: { value: !preStudyFilterState.areAllFieldsFilled.value }
        }

        )

        setFilteredData({
            filteredPlants: props?.sbus[sbuIndex]?.plants,
            filteredFactories: [],
            filteredModules: [],
            filteredStyles: [],
            filteredStyleVersions: []
        })
    }

    // Handle plant select dropdown change event
    const onPlantChange = (value) => {
        const plantIndex = filteredData?.filteredPlants?.map(p => p.code)?.indexOf(value)
        setpreStudyFilterState({
            ...preStudyFilterState,
            plantId: {
                ...preStudyFilterState.plantId,
                value: value
            },
            plantCode: {
                ...preStudyFilterState.plantCode,
                value: filteredData?.filteredPlants[plantIndex]?.code
            },
            factoryId: {
                ...preStudyFilterState.factoryId,
                value: ''
            },
            factoryCode: {
                ...preStudyFilterState.factoryCode,
                value: ''
            },
            moduleCode: {
                ...preStudyFilterState.moduleCode,
                value: ''
            },
            style: {
                ...preStudyFilterState.style,
                value: ''
            },
            styleVersion: {
                ...preStudyFilterState.styleVersion,
                value: '0'
            },
            userId: {
                value: ''
            },
            areAllFieldsFilled: { value: !preStudyFilterState.areAllFieldsFilled.value }
        })

        setFilteredData({
            ...filteredData,
            filteredFactories: filteredData?.filteredPlants[plantIndex]?.factories,
            filteredModules: [],
            filteredStyles: [],
            filteredStyleVersions: []
        })
    }

    // Handle Factory select dropdown change event
    const onFactoryChange = (value) => {
        const factoryIndex = filteredData?.filteredFactories?.map(f => f.code)?.indexOf(value)
        var modules = []
        dispatch(
            factoryActions.getModulesByFactoryCode(
                filteredData?.filteredFactories[factoryIndex]?.code,
                (data) => {
                    setFilteredData({
                        ...filteredData,
                        filteredModules: data,
                        filteredStyles: [],
                        filteredStyleVersions: []
                    })
                },
                (error) => {
                    dispatch(alertActions.triggerAlert(true, error, 'error'))
                }
            )
        );

        setpreStudyFilterState({
            ...preStudyFilterState,
            factoryId: {
                ...preStudyFilterState?.factoryId,
                value: value
            },
            factoryCode: {
                ...preStudyFilterState.factoryCode,
                value: filteredData?.filteredFactories[factoryIndex]?.code
            },
            moduleCode: {
                ...preStudyFilterState.moduleCode,
                value: ''
            },
            style: {
                ...preStudyFilterState.style,
                value: ''
            },
            styleVersion: {
                ...preStudyFilterState.styleVersion,
                value: '0'
            },
            areAllFieldsFilled: { value: !preStudyFilterState.areAllFieldsFilled.value }
        })
    }

    const onShiftChange = (value) => {
        setpreStudyFilterState({
            ...preStudyFilterState,
            shiftCode: {
                ...preStudyFilterState.shiftCode,
                value: value
            },
            areAllFieldsFilled: { value: !preStudyFilterState.areAllFieldsFilled.value }
        })
    }

    // Handle module select dropdown change event
    const onModuleChangeEvent = async (event) => {
        setFilteredData({
            ...filteredData
            , filteredStyles: []
            , filteredStyleVersions: []
        })

        setpreStudyFilterState({
            ...preStudyFilterState,
            moduleCode: {
                ...preStudyFilterState.moduleCode,
                value: event
            },
            style: {
                ...preStudyFilterState.style,
                value: ''
            },
            styleVersion: {
                ...preStudyFilterState.styleVersion,
                value: '0'
            },
            areAllFieldsFilled: { value: !preStudyFilterState.areAllFieldsFilled.value }
        })
    }

    // Handle user typed value in autocomplete, based on value fetch options from DB
    const onStyleChange = (event) => {
        console.log("On Style Change, called from autocomplete textstrokes");
        if (event != null && !!event.target?.value) {
            dispatch(
                preStudyActions.getPreStudyStyles(
                    (data) => {
                        if (data != undefined && data.length > 0) {
                            setFilteredData({
                                ...filteredData
                                , filteredStyles: data?.map(x => x.name)
                                , filteredStyleVersions: []
                            })
                        }
                    },
                    (error) => {
                        dispatch(alertActions.triggerAlert(true, error, 'error'))
                    }, preStudyFilterState.plantCode.value, preStudyFilterState.factoryCode.value, preStudyFilterState.moduleCode.value, event.target.value
                )
            );

        }

    }

    // Handle style select dropdown change event
    const onStyleValueChange = (event) => {
        if (event.target.outerText != undefined) {

            dispatch(
                preStudyActions.getPreStudyStyles(
                    (data) => {
                        if (data != undefined && data.length > 0) {
                            setFilteredData({
                                ...filteredData
                                , filteredStyleVersions: data[0].version?.map(x => { return { id: x.number.toString(), value: x.number.toString() } })
                            })
                        }
                    },
                    (error) => {
                        dispatch(alertActions.triggerAlert(true, error, 'error'))
                    }, preStudyFilterState.plantCode.value, preStudyFilterState.factoryCode.value, preStudyFilterState.moduleCode.value, event.target.outerText
                )
            );

            setpreStudyFilterState({
                ...preStudyFilterState,
                style: {
                    ...preStudyFilterState.style,
                    value: filteredData.filteredStyles.find(x => x?.toUpperCase() === event.target.outerText?.toUpperCase())
                },
                areAllFieldsFilled: { value: !preStudyFilterState.areAllFieldsFilled.value }
            })
        }
    }

    const onStyleVersionChange = (value) => {
        setpreStudyFilterState({
            ...preStudyFilterState,
            styleVersion: {
                ...preStudyFilterState.styleVersion,
                value: filteredData.filteredStyleVersions.find(x => x?.id === value)?.value
            },
            areAllFieldsFilled: { value: !preStudyFilterState.areAllFieldsFilled.value }
        })
    }


    // Clear all filters
    const filterClear = () => {
        setpreStudyFilterState(INITIAL_STATE)
        setFilteredData(INITIAL_FILTERED_DATA)
        props.onFilterClear()
    }

    const filterApply = async () => {
        const [validatedData, isValid]: any = await utilFunctions.validateFormData(preStudyFilterState)
        setpreStudyFilterState({ ...validatedData })
        if (isValid) {
            const filter: StudyPreActivityFilterStructure = {
                plantCode: preStudyFilterState.plantCode.value,
                factoryCode: preStudyFilterState.factoryCode.value,
                shiftCode: preStudyFilterState.shiftCode.value,
                module: preStudyFilterState.moduleCode.value,
                style: preStudyFilterState.style.value,
                styleVersion: preStudyFilterState.styleVersion.value.toString(),
                // id: preStudyFilterState.headerId.value
            }
            props.onFilterChange(filter)
        }
    }

    return (
        <Accordion
            className="appAccordion"
            expanded={filtersAccordion}
            onChange={(e, expanded) => setFiltersAccordion(expanded)}
        >
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>Filters</Typography>
            </AccordionSummary>
            <AccordionDetails className="contentPadding">
                <Grid container spacing={3} className="appFilterContainer">
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="SBU" variant="inline" labelMinWidth={labelMinWidth} isRequired={preStudyFilterState.sbuCode.isRequired}>
                            <SbuSelect
                                sbus={props?.sbus}
                                error={!!preStudyFilterState.sbuCode.error}
                                selectedValue={preStudyFilterState?.sbuCode?.value}
                                onSbuChange={onSbuChange}
                                isCodeRequiredInKey={true}
                                disabled={props.isPreStudyControlsDisabled}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Plant" variant="inline" labelMinWidth={labelMinWidth} isRequired={preStudyFilterState.plantCode.isRequired}>
                            <PlantSelect
                                plants={filteredData?.filteredPlants}
                                error={!!preStudyFilterState.factoryCode.error}
                                selectedValue={preStudyFilterState?.plantCode?.value}
                                onPlantChange={onPlantChange}
                                isCodeRequiredInKey={true}
                                disabled={props.isPreStudyControlsDisabled}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Factory" variant="inline" labelMinWidth={labelMinWidth} isRequired={preStudyFilterState.factoryCode.isRequired}>
                            <FactorySelect
                                factories={filteredData?.filteredFactories}
                                error={!!preStudyFilterState.factoryCode.error}
                                selectedValue={preStudyFilterState?.factoryCode?.value}
                                onFactoryChange={onFactoryChange}
                                isCodeRequiredInKey={true}
                                disabled={props.isPreStudyControlsDisabled}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Shift" variant="inline" labelMinWidth={labelMinWidth} isRequired={preStudyFilterState.moduleCode.isRequired}>
                            <ShiftSelect
                                shifts={props.shifts}
                                error={!!preStudyFilterState.shiftCode.error}
                                onShiftChange={onShiftChange}
                                selectedValue={preStudyFilterState?.shiftCode?.value}
                                disabled={props.isPreStudyControlsDisabled}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Module" variant="inline" labelMinWidth={labelMinWidth} isRequired={preStudyFilterState.moduleCode.isRequired}>
                            <ModuleSelect
                                modules={filteredData?.filteredModules}
                                error={!!preStudyFilterState.moduleCode.error}
                                selectedValue={[preStudyFilterState?.moduleCode?.value]}
                                onModuleChange={onModuleChangeEvent}
                                multiple={false}
                                disabled={props.isPreStudyControlsDisabled}
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Style" variant="inline" labelMinWidth={labelMinWidth} isRequired={preStudyFilterState.style.isRequired}>
                            <Autocomplete
                                getOptionLabel={(option) => (typeof option === 'string' && (option != null || option != undefined)) ? option : ""}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={filteredData.filteredStyles}
                                onInputChange={onStyleChange}
                                onChange={onStyleValueChange}
                                disabled={props.isPreStudyControlsDisabled}
                                value={preStudyFilterState.style.value}
                                renderInput={(params) => <TextField {...params} variant="outlined" error={!!preStudyFilterState.style.error} />
                                }
                            />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Style Version" variant="inline" labelMinWidth={labelMinWidth} isRequired={preStudyFilterState.styleVersion.isRequired}>
                            {console.log(preStudyFilterState?.styleVersion?.value)}
                            <StyleVersionSelect
                                styleVersions={filteredData?.filteredStyleVersions}
                                error={!!preStudyFilterState.styleVersion.error}
                                selectedValue={preStudyFilterState?.styleVersion?.value}
                                onStyleVersionChange={onStyleVersionChange}
                                disabled={props.isPreStudyControlsDisabled}
                            />
                        </FormControlWrapper>
                    </Grid>

                    {pageState != "CREATE" && props.showClearButton &&
                        <Grid item xs={12} sm={12} md={6} lg={3} className="appButtonGroup">
                            <Button variant="contained" onClick={filterClear}>Clear</Button>
                            <Button variant="contained" color="primary" onClick={filterApply}>Search</Button>
                        </Grid>
                    }

                </Grid>
            </AccordionDetails>
        </Accordion>
    )

}

PreStudyFilters.propTypes = {
    sbus: PropTypes.array.isRequired,
    onFilterClear: PropTypes.func,
    onFilterChange: PropTypes.func,
    pageState: PropTypes.string,
    studyHeader: PropTypes.any,
    showClearButton: PropTypes.bool,
    isPreStudyControlsDisabled: PropTypes.bool,
    shifts: PropTypes.array.isRequired
}

export default PreStudyFilters



